<template>
    <b-modal title="Print Taksiran Gadai" ok-only no-close-on-esc no-close-on-backdrop size="xl" id="modal-print-emas">
        <b-row class="mb-2">
            <b-col class="detail-data-label">Taksiran Gadai</b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col><iframe width="100%" height="300" :src="urlTaksiran" frameborder="0" allowfullscreen></iframe></b-col>
        </b-row>
        <b-row class="mb-2 align-items-center">
            <b-col class="detail-data-label d-flex align-items-center">
                Kode Cetak Simulasi :
                <span
                    class="ml-2 cursor-pointer text-primary font-weight-bold d-flex align-items-center"
                    @click="$emit('copy-code', codeSimulasi)"
                    title="Klik untuk menyalin"
                >
                    {{ codeSimulasi }}
                    <i class="fa fa-copy ml-2"></i>
                </span>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-cetak-emas',
    props: {
        urlTaksiran: { type: String, default: null },
        codeSimulasi: { type: String, default: null },
    },
}
</script>
